import reducer from './onboardingClient.reducer';
import * as constant from './onboardingClient.constant';
import * as action from './onboardingClient.action';
import * as selector from './onboardingClient.selector';
import saga from './onboardingClient.saga';
import initialState from './onboardingClient.initialState';

export default {
  reducer,
  action,
  constant,
  selector,
  name: constant.NAME,
  saga,
  initialState,
};
